// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Validator from "@classes/Validator";


const collections = [
	require("./collections/CollectionKyc").default,
	require("./collections/CollectionExperience").default,
	require("./collections/CollectionProductClass").default,
	require("./collections/CollectionPEP").default,
	require("./collections/CollectionFATCA").default,
	require("./collections/CollectionAccountType").default,
	require("./collections/CollectionGDPR").default
];

export default class Fields extends React.PureComponent {
	static propTypes = {
		title: PropTypes.string.isRequired,
		validFields: PropTypes.object.isRequired,
		fields: PropTypes.object.isRequired,
		numberLocaleFormatter: PropTypes.func.isRequired,
		onFieldChange: PropTypes.func.isRequired,
		onFieldBlur: PropTypes.func.isRequired,
		onSelectChange: PropTypes.func.isRequired,
		onOptionsListChange: PropTypes.func.isRequired,
		onCheckboxChange: PropTypes.func.isRequired
	};

	static getFieldNames = _getFieldNames;
	static getHiddenDefaultFields = _getHiddenDefaultFields;
	static setupFieldsState = _setupFieldsState;

	render() {
		const {props} = this;
		const {title, fields, validFields, numberLocaleFormatter, onFieldChange, onFieldBlur, onOptionsListChange, onCheckboxChange, session} = props;
		const collectionProps = {
			fields,
			validFields,
			numberLocaleFormatter,
			onFieldChange,
			onFieldBlur,
			onSelectChange: this._onSelectChange,
			onOptionsListChange,
			onCheckboxChange,
			session
		};

		return (
			<div className="Cob-Fields">
				<h2>{title}</h2>

				{collections.map((Collection, index) => (
					<Collection {...collectionProps} key={index} index={index}/>
				))}
			</div>
		);
	}

	// Internal methods
	_onSelectChange = (option, index) => {
		const {onSelectChange} = this.props;
		const stateFieldKey = (
			option.name.indexOf("checkbox_customer_reason_business_relationship") === 0 ? "checkbox_customer_reason_business_relationship" :
				option.name.indexOf("checkbox_customer_kyc_net_income") === 0 ? "checkbox_customer_kyc_net_income" :
					option.name.indexOf("checkbox_customer_kyc_purpose") === 0 ? "checkbox_customer_kyc_purpose" :
						option.name.indexOf("checkbox_customer_kyc_deposit") === 0 ? "checkbox_customer_kyc_deposit" :
							option.name.indexOf("checkbox_customer_kyc_empl") === 0 ? "checkbox_customer_kyc_empl" :
								option.name.indexOf("checkbox_customer_kyc_inv") === 0 ? "checkbox_customer_kyc_inv" :
									option.name.indexOf("checkbox_aml_origin") === 0 ? "checkbox_aml_origin" :
										null
		);

		if (stateFieldKey) {
			onSelectChange(stateFieldKey, option, index);
		}
	};

	// Static methods
	static fieldValidator = (name, value) => {
		if (name === "poa_company_socialsecuritynr") {
			return Validator.validateSsn(value, false);
		}
		else if (name === "poa_company_email") {
			return Validator.validateEmail(value);
		}
		else {
			return value.length > 0;
		}
	};
}


// PRIVATE FUNCTIONS
function _getFieldNames() {
	return [
		"checkbox_account_isk",
		"checkbox_account_naked",
		"radio_account_type_open",
		"radio_reseller_poa",

		"newAccountCheckbox1",
		"newAccountCheckbox2",
		"newAccountCheckbox3",
		"newAccountCheckbox5",
		"newAccountSlider1",
		"newAccountSlider2",
		"newAccountSlider3",
		"newAccountSlider4",
		"newAccountSlider5",

		"checkbox_customer_reason_business_relationship_saving",
		"checkbox_customer_reason_business_relationship_assetmanagement",
		"checkbox_customer_reason_business_relationship_other",
		"customer_reason_business_relationship_other",

		"checkbox_customer_kyc_purpose_pension",
		"checkbox_customer_kyc_purpose_private_consumption",
		"checkbox_customer_kyc_purpose_financial_security",
		"checkbox_customer_kyc_purpose_relative",
		"checkbox_customer_kyc_purpose_beneficiary",
		"checkbox_customer_kyc_purpose_saving",
		"checkbox_customer_kyc_purpose_other",
		"customer_kyc_purpose_other",

		"checkbox_customer_kyc_inv_own_part",
		"checkbox_customer_kyc_inv_through_poa",
		"checkbox_customer_kyc_inv_other",
		"customer_kyc_inv_other",

		"radio_aml_purpose_gains",

		"checkbox_aml_origin_savings",
		"checkbox_aml_origin_heritage_gift",
		"checkbox_aml_origin_salary",
		"checkbox_aml_origin_re_sales",
		"checkbox_aml_origin_capital_return",
		"checkbox_aml_origin_other",
		"aml_origin_other_desc",

		"checkbox_customer_kyc_empl_other_until_further_notice",
		"checkbox_customer_kyc_empl_other_temporary_employment",
		"checkbox_customer_kyc_empl_unemployed",
		"checkbox_customer_kyc_empl_retired",
		"checkbox_customer_kyc_empl_student",
		"checkbox_customer_kyc_empl_self_employed",
		"checkbox_customer_kyc_empl_other",
		"customer_kyc_empl_other",

		"checkbox_customer_kyc_net_income_0_15000",
		"checkbox_customer_kyc_net_income_15000_30000",
		"checkbox_customer_kyc_net_income_30000_50000",
		"checkbox_customer_kyc_net_income_50000",

		"checkbox_customer_kyc_deposit_swedish_bank",
		"checkbox_customer_kyc_deposit_foreign_bank",
		"checkbox_customer_kyc_deposit_swedish_insurance",
		"checkbox_customer_kyc_deposit_foreign_insurance",
		"checkbox_customer_kyc_deposit_pension",
		"checkbox_customer_kyc_deposit_employer",
		"checkbox_customer_kyc_deposit_inheritance",
		"checkbox_customer_kyc_deposit_other",
		"customer_kyc_deposit_other",

		"customer_kyc_sek_invested",

		"kyc_experience_aktier_investments",
		"radio_kyc_knowledge_aktier",

		"kyc_experience_fonder_investments",
		"radio_kyc_knowledge_fonder",

		"kyc_experience_obligationer_investments",
		"radio_kyc_knowledge_obligationer",

		"kyc_experience_aio_investments",
		"radio_kyc_knowledge_aio",

		"kyc_experience_sprinter_investments",
		"radio_kyc_knowledge_sprinter",

		"kyc_experience_kreditcertifikat_investments",
		"radio_kyc_knowledge_kreditcertifikat",

		"kyc_experience_autocalls_investments",
		"radio_kyc_knowledge_autocalls",

		"kyc_experience_derivat_investments",
		"radio_kyc_knowledge_derivat",

		"radio_customer_pep",
		"radio_customer_us_person",

		"radio_product_class_a"
	];
}

function _getHiddenDefaultFields() {
	console.log(this.props.partner);

	return [
		// Avgiftsstruktur
		{name: "account_account_fee", value: ""},
		{name: "account_advice_fee", value: ""},
		{name: "account_disk_fee", value: ""},
		{name: "account_insurance_fee", value: ""},
		{name: "account_performance_fee", value: ""},
		{name: "account_performance_hurdle_fee", value: ""},
		{name: "account_total_fee", value: ""},

		{name: "checkbox_customer_kyc_non_proff", value: "yes"},
		{name: "radio_reseller_poa", value: "full"},

		// Partner info
		{name: "partner_firstname", value: ""},
		{name: "partner_lastname", value: ""},
		{name: "partner_company", value: this.props.partner.partnerCustomerName},
		{name: "partner_customer_number", value: this.props.partner.partnerCustomerNo}
	];
}

function _setupFieldsState(parent) {

	return {

		"newAccountCheckbox1": {
			checked: true
		},
		"newAccountCheckbox2": {
			checked: true
		},
		"newAccountCheckbox3": {
			checked: false
		},
		"newAccountCheckbox5": {
			checked: true
		},
		"newAccountSlider1": "",
		"newAccountSlider2": "",
		"newAccountSlider3": "",
		"newAccountSlider4": "",
		"newAccountSlider5": "",

		"radio_reseller_poa": {
			options: [
				{label: "Diskretionär fullmakt", value: "full", name: "full", checked: true}
			]
		},

		"checkbox_customer_kyc_purpose": {
			index: -1,
			options: [
				{label: "Pension", value: "yes", name: "checkbox_customer_kyc_purpose_pension"},
				{label: "Privat konsumtion", value: "yes", name: "checkbox_customer_kyc_purpose_private_consumption"},
				{label: "Ekonomisk trygghet", value: "yes", name: "checkbox_customer_kyc_purpose_financial_security"},
				{label: "Till närstående", value: "yes", name: "checkbox_customer_kyc_purpose_relative"},
				{label: "Jag är förmånstagare", value: "yes", name: "checkbox_customer_kyc_purpose_beneficiary"},
				{label: "Sparande/placering", value: "yes", name: "checkbox_customer_kyc_purpose_saving"},
				{label: "Annat (beskriv)", value: "yes", name: "checkbox_customer_kyc_purpose_other"}
			]
		},
		"customer_kyc_purpose_other": "",

		"checkbox_customer_reason_business_relationship": {
			index: -1,
			options: [
				{label: "Sparande", value: "yes", name: "checkbox_customer_reason_business_relationship_saving"},
				{
					label: "Kapitalförvaltning",
					value: "yes",
					name: "checkbox_customer_reason_business_relationship_assetmanagement"
				},
				{label: "Annat (beskriv)", value: "yes", name: "checkbox_customer_reason_business_relationship_other"}
			]
		},
		"customer_reason_business_relationship_other": "",

		"checkbox_customer_kyc_inv": {
			index: -1,
			options: [
				{
					label: "För egen del (eller av mig helägt företag)",
					value: "yes",
					name: "checkbox_customer_kyc_inv_own_part"
				},
				{label: "För någon annan genom fullmakt", value: "yes", name: "checkbox_customer_kyc_inv_through_poa"},
				{label: "Annat (beskriv)", value: "yes", name: "checkbox_customer_kyc_inv_other"}
			]
		},
		"customer_kyc_inv_other": "",

		"radio_aml_purpose_gains": {
			options: [
				{label: "Ja", value: "yes"},
				{label: "Nej", value: "no"}
			]
		},

		"checkbox_aml_origin": {
			index: -1,
			options: [
				{label: "Sparande", value: "yes", name: "checkbox_aml_origin_savings"},
				{label: "Arv/gåva", value: "yes", name: "checkbox_aml_origin_heritage_gift"},
				{label: "Lön/pension", value: "yes", name: "checkbox_aml_origin_salary"},
				{label: "Fastighetsförsäljning", value: "yes", name: "checkbox_aml_origin_re_sales"},
				{label: "Kapitalavkastning", value: "yes", name: "checkbox_aml_origin_capital_return"},
				{label: "Annat (beskriv)", value: "yes", name: "checkbox_aml_origin_other"}
			]
		},
		"aml_origin_other_desc": "",

		"checkbox_customer_kyc_empl": {
			index: -1,
			options: [
				{
					label: "Tillsvidareanställd",
					value: "yes",
					name: "checkbox_customer_kyc_empl_other_until_further_notice"
				},
				{
					label: "Visstidsanställd",
					value: "yes",
					name: "checkbox_customer_kyc_empl_other_temporary_employment"
				},
				{label: "Arbetssökande", value: "yes", name: "checkbox_customer_kyc_empl_unemployed"},
				{label: "Pensionerad", value: "yes", name: "checkbox_customer_kyc_empl_retired"},
				{label: "Student", value: "yes", name: "checkbox_customer_kyc_empl_student"},
				{label: "Egen företagare", value: "yes", name: "checkbox_customer_kyc_empl_self_employed"},
				{label: "Annat (beskriv)", value: "yes", name: "checkbox_customer_kyc_empl_other"}
			]
		},
		"customer_kyc_empl_other": "",

		"checkbox_customer_kyc_net_income": {
			index: -1,
			options: [
				{label: "0—15 tkr", value: "yes", name: "checkbox_customer_kyc_net_income_0_15000"},
				{label: "15—30 tkr", value: "yes", name: "checkbox_customer_kyc_net_income_15000_30000"},
				{label: "30—50 tkr", value: "yes", name: "checkbox_customer_kyc_net_income_30000_50000"},
				{label: "> 50 tkr", value: "yes", name: "checkbox_customer_kyc_net_income_50000"}
			]
		},

		"checkbox_customer_kyc_deposit": {
			index: -1,
			options: [
				{label: "Svensk bank/institut", value: "yes", name: "checkbox_customer_kyc_deposit_swedish_bank"},
				{label: "Utländsk bank/institut", value: "yes", name: "checkbox_customer_kyc_deposit_foreign_bank"},
				{
					label: "Svenskt försäkringsbolag",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_swedish_insurance"
				},
				{
					label: "Utländskt försäkringsbolag",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_foreign_insurance"
				},
				{label: "Pension", value: "yes", name: "checkbox_customer_kyc_deposit_pension"},
				{label: "Från min arbetsgivare", value: "yes", name: "checkbox_customer_kyc_deposit_employer"},
				{
					label: "Förmånstagare till depå genom arv",
					value: "yes",
					name: "checkbox_customer_kyc_deposit_inheritance"
				},
				{label: "Annat (beskriv)", value: "yes", name: "checkbox_customer_kyc_deposit_other"}
			]
		},
		"customer_kyc_deposit_other": "",

		"customer_kyc_sek_invested": "",

		"kyc_experience_aktier_investments": "",
		"radio_kyc_knowledge_aktier": {options: _createKnowledgeOptions()},

		"kyc_experience_fonder_investments": "",
		"radio_kyc_knowledge_fonder": {options: _createKnowledgeOptions()},

		"kyc_experience_obligationer_investments": "",
		"radio_kyc_knowledge_obligationer": {options: _createKnowledgeOptions()},

		"kyc_experience_aio_investments": "",
		"radio_kyc_knowledge_aio": {options: _createKnowledgeOptions()},

		"kyc_experience_sprinter_investments": "",
		"radio_kyc_knowledge_sprinter": {options: _createKnowledgeOptions()},

		"kyc_experience_kreditcertifikat_investments": "",
		"radio_kyc_knowledge_kreditcertifikat": {options: _createKnowledgeOptions()},

		"kyc_experience_autocalls_investments": "",
		"radio_kyc_knowledge_autocalls": {options: _createKnowledgeOptions()},

		"kyc_experience_derivat_investments": "",
		"radio_kyc_knowledge_derivat": {options: _createKnowledgeOptions()},

		"radio_customer_pep": {options: _createCustomerPepOptions()},
		"radio_customer_us_person": {options: _createCustomerUsPersonOptions()},

		"radio_product_class_a": {options: _createYesNoOptions()},

		"checkbox_customer_kyc_gdpr": {
			checked: false
		}
	};
}

function _createKnowledgeOptions() {
	return [
		{label: "Ingen", value: "ingen", checked: true},
		{label: "Någon", value: "nagon"},
		{label: "Omfattande", value: "omfattande"}
	];
}

function _createCustomerPepOptions() {
	return [
		{label: "Nej", value: "no"},
		{label: "Ja (fyll i 'Frågeformulär PEP')", value: "yes"}
	];
}

function _createCustomerUsPersonOptions() {
	return [
		{label: "Nej", value: "no"},
		{label: "Ja (det är ej möjligt att öppna konto)", value: "yes"}
	];
}

function _createYesNoOptions() {
	return [
		{label: "Ja", value: "yes"},
		{label: "Nej", value: "no"}
	];
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/auagfonder/Fields/Fields.js